/* The navigation drawer (app.ts renderDrawer ~832). The section list from
   sections(), the active section highlighted; its own close button and the
   scrim (N32) both close it. Selecting a section never closes the drawer —
   only the hamburger, the close button, the scrim, or Escape do (per Trevor,
   Aug 17 2026). Same DOM classes as styles.css. */
import type { JSX } from "react";
import { useAppState } from "./store";
import { sections } from "./sections";

export function Drawer(): JSX.Element {
  const { state, store } = useAppState();
  const items = sections(store);
  return (
    <>
      <nav id="drawer" aria-label="Main menu" hidden={!state.menuOpen}>
        {state.menuOpen && (
          <>
            <button
              className="drawer-close"
              aria-label="Close menu"
              onClick={() => store.toggleMenu(false)}
            >
              &times;
            </button>
            {items.map((s) => (
              <button
                key={s.label}
                className={"nav-item" + (s.views.some((v) => v.current()) ? " active" : "")}
                onClick={() => s.open()}
              >
                {s.label}
              </button>
            ))}
          </>
        )}
      </nav>
      <div
        id="drawer-scrim"
        aria-hidden="true"
        hidden={!state.menuOpen}
        onClick={() => store.toggleMenu(false)}
      />
    </>
  );
}
